

























































import {Component, Prop, Vue} from 'vue-property-decorator'
import Preview from "@/components/Preview.vue";
import MenusStore from "@/store/modules/MenusStore";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import ThemeCategoryVariablesStore from "@/store/modules/ThemeCategoryVariablesStore";
import ThemeItemVariablesStore from "@/store/modules/ThemeItemVariablesStore";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import SelectionsStore from "@/_common/api/store/modules/SelectionsStore";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import ThemesStore from "@/store/modules/ThemesStore";
import StoresStore from '@/store/modules/StoresStore';
import GenerationsStore from '@/store/modules/GenerationsStore';

@Component({
    components: {
        Preview,
    },
})
export default class PreviewPage extends Vue {
    private monitors = [
        {"size" : 22,
        "resolution": {"width": 1054, "height": 1684}
        },
        {"size" : 24,
        "resolution": {"width": 1084, "height": 1924}
        }
    ];

    private createdFlg = false;

    async created() {
        const menuId: number = Number(this.$route.params.menuId);

        await MenusStore.init();

        const storeId: number = MenusStore.menuById[menuId].store_ids ? Number(MenusStore.menuById[menuId].store_ids[0]) : Number(StoresStore.all[0].code);
        await DeliousItemsStore.init({storeId: storeId, periodId: GenerationsStore.selected.period_no});

        await CategoriesStore.init(menuId);
        await CategoryItemsStore.init(menuId);

        const themeId: number = MenusStore.menuById[menuId].theme_id;
        ThemesStore.selectTheme(themeId)
        ThemeVariableStore.init({themeId: themeId, menuId: menuId});
        ThemeCategoryVariablesStore.init({themeId: themeId, menuId: menuId});
        ThemeItemVariablesStore.init(themeId);
        this.createdFlg = true;
    }

    get categories() {
        return CategoriesStore.all;
    }

    get categoryItems() {
        return CategoryItemsStore.all;
    }

    get cmsItems() {
        return ItemsStore.all;
    }

    get selections() {
        return SelectionsStore.all;
    }

    get condimentGroups() {
        return CondimentGroupsStore.all;
    }

    get themeVariable() {
        return ThemeVariableStore.all;
    }

    get themeCategoryVariables() {
        return ThemeCategoryVariablesStore.all;
    }

    get themeItemVariables() {
        return ThemeItemVariablesStore.all;
    }

    get deliousItems() {
        return DeliousItemsStore.all;
    }

    get pagePath() {
        const pageName = this.$route.params.pageName;
        const page: CMS.Page = ThemesStore.selectedThemePageByName[pageName];
        return page ? page.preview_path : "root";
    }

    get resolution() :any{
        for (let i=0; i < this.monitors.length; i++) {
            if (this.monitors[i].size == this.isSelectedMonitor) {
                return this.monitors[i].resolution;
            }
        }
        return this.monitors[0].resolution;
    }

    private isSelectedMonitor: number = this.monitors[0].size;

    private isExpand: boolean = false;

    private onClickExpand(): void {
        this.isExpand = true;
    }

    private onClickShrink(): void {
        this.isExpand = false;
    }

    private onClickMonitor(size: number): void {
        this.isSelectedMonitor = size;
    }

    private close(): void {
        window.close();
    }
}

